import React, { useState } from "react";
import PrintDialog from "../PrintDialog";
import { useLanguage } from "../../../Language";
import { useHoldStatus } from "./useHoldStatus";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { useIsMobile } from "@tlc/ui/useIsMobile";

interface AccountHoldsDialogProps {
  fetchHolds: () => Promise<HostSystemItemView[]>;
  disabled?: boolean;
}

export default function AccountPrintHoldsDialog({
  fetchHolds,
  disabled,
}: AccountHoldsDialogProps) {
  const { translate } = useLanguage();
  const isMobile = useIsMobile();
  const { getHoldStatusData } = useHoldStatus();
  const [printHoldsData, setPrintHoldsData] = useState<HostSystemItemView[]>(
    [],
  );

  const handleLoadHolds = async () => {
    const data = await fetchHolds();
    setPrintHoldsData(data);
  };

  const buildHtml = () => {
    if (!printHoldsData || printHoldsData.length === 0) return "";

    const isSerial = printHoldsData.some(
      (hold) =>
        (hold.enumeration && hold.enumeration.length > 0) ||
        (hold.chronology && hold.chronology.length > 0),
    );

    let html = `
      <div>
        <h2 align="center" style="text-transform: capitalize;">${translate(
          "requests",
        )}</h2>
        <table width="100%" cellpadding="5">
          <tbody>
          ${printHoldsData
            .map((hold, index) => {
              const data = getHoldStatusData(hold);

              let statusHtml = "";
              if (data) {
                if (data.isSuspended) {
                  statusHtml = `${data.statusLabel}: <span>${data.statusValue}</span><br> 
                    <span>${data.untilLabel}</span> <span>${data.untilValue}</span>`;
                } else {
                  statusHtml = `${data.statusLabel}: <span>${data.statusValue}</span>`;
                }
              }

              return `
              <tr>
                <td valign="top" style="padding: 12px 0; border-bottom: 1px solid #eee;">
                  <p style="margin: 0 0 8px; font-weight: bold; font-size: 16px">
                    ${index + 1}. ${hold.title ?? ""} ${hold.resource?.shortAuthor ?? hold.author ?? ""}
                  </p>

                ${isSerial ? 
                  `<div>
                    <span style="color: #000000;">${translate("exportData_chronology")}: </span>
                    <span>${hold.chronology ?? ""}</span>
                  </div>
                  <div>
                    <span style="color: #000000;">${translate("exportData_numbering")}: </span>
                    <span>${hold.enumeration ?? ""}</span>
                  </div>
                  `
                : ""
                }

                 <div style="font-size: 14px; display: flex; flex-direction: column; gap: 4px;">
                  <div>
                    ${statusHtml}
                  </div>
                  <div>
                    <span style="color: #000000;">${translate("exportData_pickupLocation")}: </span>
                    <span>${hold.holdPickupBranch ?? ""}</span>
                  </div>
                </td>
              </tr>
            `;
            })
            .join("")}
          </tbody>
        </table>
      </div>
    `;                          
    return html;
  };

  return (
    <PrintDialog
      buttonText={`${translate("print")} ${translate("requests")}`}
      dialogTitle={translate("requests")}
      htmlContent={buildHtml()}
      disabled={disabled}
      maxWidth={"md"}
      fullScreen={isMobile}
      onOpenButtonClick={handleLoadHolds}
    />
  );
}
